import { useDispatch, useSelector } from "react-redux";
import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function DeleteQualification({
  selectedData,
  handleDeleteQualification,
  data,
  isOpen,
  setOpen,
}) {
  const dispatch = useDispatch();
  const { expChangeLoading } = useSelector((state) => state.counsilor);

  const handleDelete = () => {
    handleDeleteQualification(
      selectedData?.item,
      selectedData?.qualificationType === "exp" ? "experience" : "education"
    );
  };

  const modalTitle =
    selectedData?.qualificationType === "exp"
      ? "Delete Councillor Experience"
      : "Delete Councillor Education";

  return (
    <ModalComp
      title={modalTitle}
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setOpen(false)}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={expChangeLoading}
          handleSecondaryBtn={handleDelete}
          secondaryBtnvariant="danger"
          secondaryBtnText="Delete"
        />
      }
      open={isOpen}
      setOpen={(Value) => setOpen(Value)}
    >
      {`Are you sure you want to delete the data ${
        data?.item?.title || data?.item?.course_name
      } `}
    </ModalComp>
  );
}

export default DeleteQualification;
